import { format, isValid } from 'date-fns';

export const convertDatetimeToDate = (startDate: string | null | undefined): string =>
	startDate != null && isValid(new Date(startDate))
		? format(new Date(startDate), 'yyyy-MM-dd')
		: '';
